import { render, staticRenderFns } from "./ResizerElement.vue?vue&type=template&id=862c66c2&"
import script from "./ResizerElement.vue?vue&type=script&lang=js&"
export * from "./ResizerElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports